import { useContext } from "react";
import { PatientInsuranceModalContext } from "./PatientInsuranceProvider";

export const usePatientInsuranceModal = () => {
  return useContext(PatientInsuranceModalContext);
};
